module.exports = {
  "userView": {
    "name": "user view",
    "class": "view",
    "properties": {
      "userId": "number",
      "viewedUserId": "number"
    }
  },
  "userEdit": {
    "name": "user edit",
    "class": "interaction",
    "properties": {
      "userId": "number"
    }
  },
  "usersSearch": {
    "name": "users search",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "term": "string",
      "total": "number"
    }
  },
  "userFollow": {
    "name": "user follow",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "followedUserId": "number"
    }
  },
  "userUnfollow": {
    "name": "user unfollow",
    "class": "interaction",
    "properties": {
      "userId": "number",
      "followedUserId": "number"
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./events.yaml
// module id = 415
// module chunks = 0